export const PATH = {
  DEFAULT: '/',
  PROFILE: '/profile',
  STAMPS: '/stamps',
  NOTICE: '/notice',
  MEDIA: '/media',
  LOGIN: '/login',
};

export const ADMIN_PATH = {
  DEFAULT: '/admin',
  MAIN: '/admin/main',
  USERS: '/admin/users',
  STAMPS: '/admin/stamps',
  STAMPS_ADD: '/admin/stamps/add',
  NOTICE: '/admin/notice',
  NOTICE_ADD: '/admin/notice/add',
  MEDIA: '/admin/media',
};
